module.exports = __webpack_public_path__ + "static/media/bigButton_bottom.97360244.svg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/stravaAuth/img/bigButton_bottom.svg
// module id = 603
// module chunks = 0